export const _en = {
    groups: {
        layer: {
            libelle: "Groups"
        },
        buttons: {
            add: {
                label: "Add group"
            },
            del: {
                label: "Delete group"
            }
        },
        dialog: {
            creation: {
                title: "Add a new group"
            },
            edition: {
                title: "Add a new group"
            },
            deletion: {
                title: "Delete a group"
            }
        },
        deletedCheckBox: {
            label: "Display deleted data"
        }
    }
};

export const _fr = {
    groups: {
        layer: {
            libelle: "Groupes"
        },
        buttons: {
            add: {
                label: "Groupe"
            },
            del: {
                label: "Supprimer un groupe"
            }
        },
        modal: {
            creation: {
                title: "Ajout d'un groupe"
            },
            edition: {
                title: "Édition d'un groupe"
            },
            deletion: {
                title: "Supprimer un groupe"
            }
        },
        deletedCheckBox: {
            label: "Afficher les éléments archivés"
        }
    }
};